import { Sections } from '../components/Sections/Sections'
import { OnlineFollowersActivity } from './OnlineFollowersActivity'
import { AudienceDemographics } from './AudienceDemographics'
import { LocationAndLanguage } from './LocationAndLanguage'

export const Audience = () => {
  return (
    <Sections>
      <OnlineFollowersActivity />
      <AudienceDemographics />
      <LocationAndLanguage />
    </Sections>
  )
}
